export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const OPEN_USER_PROFILE_SIDEBAR = 'OPEN_USER_PROFILE_SIDEBAR';
export const CLOSE_USER_PROFILE_SIDEBAR = 'CLOSE_USER_PROFILE_SIDEBAR';
export const SET_CONVERSATION_NAME_IN_OPEN_CHAT = 'SET_CONVERSATION_NAME_IN_OPEN_CHAT';
export const CLOSE_CONTACT_SIDEBAR = "CLOSE_CONTACT_SIDEBAR";
export const OPEN_CONTACT_SIDEBAR = "CLOSE_CONTACT_SIDEBAR";